export const localStorageConstants = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  SEARCH_TICKETS: 'SEARCH_TICKETS',
  CUSTOMER_FILTER: 'CUSTOMER_FILTER',
  LOCATION_FILTER: 'LOCATION_FILTER',
  SUPPLIER_FILTER: 'SUPPLIER_FILTER',
  COMMODITY_FILTER: 'COMMODITY_FILTER',
  STATUS_FILTER: 'STATUS_FILTER',
  DATE_RANGE_FILTER: 'DATE_RANGE_FILTER',
  PAGE_SIZE: 'PAGE_SIZE',
  CURRENT_PAGE: 'CURRENT_PAGE',
  SORT_COLUMN: 'SORT_COLUMN',
  SORT_DIRECTION: 'SORT_DIRECTION',
  RECENTLY_UPDATED_DATE_FILTER: 'RECENTLY_UPDATED_DATE_FILTER',
  SEARCH_CURRENT_PAGE: 'SEARCH_CURRENT_PAGE',
  SEARCH_PAGE_SIZE: 'SEARCH_PAGE_SIZE',
  APPLIED_FILTERS: 'APPLIED_FILTERS',
  IS_FILTER_APPLIED: 'IS_FILTER_APPLIED',
  RETRY_TICKET_API_COUNT: 'RETRY_TICKET_API_COUNT',
  AD_LOGIN_ERROR: 'AD_LOGIN_ERROR',
  SUPPLIER_INITIAL_PERMISSIONS: 'SUPPLIER_INITIAL_PERMISSIONS',
  USER_INITIAL_PERMISSIONS: 'USER_INITIAL_PERMISSIONS',
  LAST_TICKET_DATE: 'LAST_TICKET_DATE',
  CUSTOMER_ACCESS_MAPPING: 'CUSTOMER_ACCESS_MAPPING',
  TICKET_DETAIL_NAV_LIST: 'TICKET_DETAIL_NAV_LIST',
  TICKET_LIST_URL: 'TICKET_LIST_URL',
  LAST_LOGIN_API_TRIGGERED: 'LAST_LOGIN_API_TRIGGERED',
  VIEWED_TICKETS: 'VIEWED_TICKETS',
  VIEWED_IMAGES: 'VIEWED_IMAGES',
  DOCUMENTS_VIEWED_DOWNLOADED: 'DOCUMENTS_VIEWED_DOWNLOADED',
  IMAGES_DOWNLOADED: 'IMAGES_DOWNLOADED',
} as const
